/*
* Copyright (C) Regione Lombardia
*/
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@shared/shared.module';
import { PagesGestioneOperaCreaOperaComponent } from './crea-opera/crea-opera.component';
import { PagesGestioneOperaDettaglioOperaComponent } from './dettaglio-opera/dettaglio-opera.component';
import { PagesGestioneOperaRoutingModule } from './gestione-opera.routing';
import { PagesGestioneOperaModificaOperaComponent } from './modifica-opera/modifica-opera.component';
import { PagesGestioneOperaRicercaOperaComponent } from './ricerca-opera/ricerca-opera.component';
import { PagesGestioneOperaToolkitModule } from './_toolkit/toolkit.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        NgbModule,
        ReactiveFormsModule,
        FormsModule,
        PagesGestioneOperaRoutingModule,
        PagesGestioneOperaToolkitModule,
    ],
    declarations: [
        PagesGestioneOperaCreaOperaComponent,
        PagesGestioneOperaDettaglioOperaComponent,
        PagesGestioneOperaModificaOperaComponent,
        PagesGestioneOperaRicercaOperaComponent,
    ],
    exports: [
        PagesGestioneOperaCreaOperaComponent,
        PagesGestioneOperaDettaglioOperaComponent,
        PagesGestioneOperaModificaOperaComponent,
        PagesGestioneOperaRicercaOperaComponent,
    ],
})
export class PagesGestioneOperaModule { }
